import React from 'react';
import type { MatrixQuestion as MatrixQuestionType } from './survey.types';
import { useLanguageStore } from '../../stores/languageStore';

interface MatrixQuestionProps {
  question: MatrixQuestionType;
  value: Record<number, number>;
  onChange: (value: Record<number, number>) => void;
  error?: string;
  displayNumber?: number;
}

export const MatrixQuestion: React.FC<MatrixQuestionProps> = ({
  question,
  value,
  onChange,
  error,
  displayNumber,
}) => {
  const languageCode = useLanguageStore((state) => state.code);
  const handleAnswerChange = (questionNumber: number, answerNumber: number) => {
    onChange({
      ...value,
      [questionNumber]: answerNumber,
    });
  };

  return (
    <div className="survey-question matrix-question">
      <label className="question-label">
        {displayNumber != null && (
          <span className="question-number">{displayNumber}.</span>
        )}
        <span dangerouslySetInnerHTML={{ __html: question.question_text[languageCode] }} />
        {question.is_required && <span className="required-indicator">*</span>}
      </label>
      <div className="matrix-container">
        <div className="matrix-table">
          <div className="matrix-header">
            <div className="matrix-cell matrix-corner"></div>
            {question.answers.map((answer) => (
              <div key={answer.answer_number} className="matrix-cell matrix-header-cell">
                {answer.answer_text[languageCode]}
              </div>
            ))}
          </div>
          {/* Render each sub-question as a row on the y-axis */}
          {question.questions.map((subQuestion) => (
            <div key={subQuestion.question_number} className="matrix-row">
              <div className="matrix-cell matrix-row-header">
                {subQuestion.question_text[languageCode]}
              </div>
              {question.answers.map((answer) => (
                <div key={answer.answer_number} className="matrix-cell matrix-input-cell">
                  <label className="matrix-radio-label">
                    <span className="matrix-answer-caption">
                      {answer.answer_text[languageCode]}
                    </span>
                    <input
                      type="radio"
                      name={`matrix_${question.question_number}_row_${subQuestion.question_number}`}
                      checked={value[subQuestion.question_number] === answer.answer_number}
                      onChange={() => handleAnswerChange(subQuestion.question_number, answer.answer_number)}
                      className="matrix-radio"
                    />
                  </label>
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
      {error && <div className="error-message">{error}</div>}
    </div>
  );
};
